import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "tab",
    "content"
  ];

  open(e) {
    const index = Number(e.currentTarget.dataset.tabIndex);
    this.tabTargets.forEach((t, i) => {
      i === index ? t.classList.add("is-active") : t.classList.remove("is-active");
    });
    this.contentTargets.forEach((c, i) => {
      i === index ? c.style.display = "" : c.style.display = "none";
    });
  }

  connect() {
  }
}
